<template>
  <div class="card">
    <div style="position: relative; width: 100%">
      <img :src="image" class="card__img" />
      <span
        v-if="completo"
        style="position: absolute; top: 12px; left: 12px; padding: 4px 10px; border-radius: 4px; background: #fff; color: #000; font-size: 12px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase"
      >
        {{ $t('experience.completo') }}
      </span>
    </div>
    <div class="card__description">
      <span class="card__description--title">{{ title }}</span>
      <span class="card__description--subtitle" v-html="subtitle"></span>
    </div>
  </div>
</template>

<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    title: String,
    subtitle: String,
    image: String,
    // Lo enciende quien pinta la tarjeta, con el `soldOut` del listado. Por
    // defecto apagado: sin dato, la tarjeta se ve como siempre.
    completo: { type: Boolean, default: false },
    width: { type: String, default: '100%' },
    height: { type: String, default: '100%' },
    imageDesktopHeight: { type: String, default: '100%' },
    imageHeight: { type: String, default: '240px' },
    borderRadius: { type: String, default: '20px' },
    cursor: { type: String, default: 'pointer' }
  })

  const cardWidth = computed(() => props.width)
</script>

<style lang="scss" scoped>
  @import '@/scss/mixings';

  .card {
    @include d-flex(column, flex-start, flex-start);
    width: v-bind(width);
    height: v-bind(height);
    padding-bottom: 30px;
    border-radius: v-bind(borderRadius);
    border: 1px solid var(--neutral-20);
    background: var(--theme-color);
    cursor: v-bind(cursor);
    @media screen and (min-width: $sm-breakpoint) {
      transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    &__img {
      width: 100%;
      height: v-bind(imageHeight);
      border-top-left-radius: v-bind(borderRadius);
      border-top-right-radius: v-bind(borderRadius);
      object-fit: cover;
      @media screen and (min-width: $sm-breakpoint) {
        height: v-bind(imageDesktopHeight);
      }
    }
    &__description {
      @include d-flex(column, flex-start, initial);
      gap: 8px;
      align-self: stretch;
      padding: 24px 24px 0px 24px;
      &--title {
        font-family: 'OnAir-text-black';
        color: #0b2739;
        font-size: 18px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
      }
      &--subtitle {
        font-family: 'OnAir-text-bold';
        color: #6b6c6f;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
      }
    }
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    }
  }

  .selected-card {
    transition: box-shadow 0.3s ease;
  }
</style>
